<template>
    <TopNav></TopNav>
		<h1>Ohm's Law Calculator</h1>
		<fieldset>
      <legend>Ohm's Law Calculator</legend>
      <label for="vo" class="leftLabel">Voltage (V):</label> <input type="number" v-model.number="voltage" step="any" @input="onVoltageChange" autofocus id="vo"> <label for="vo">Volts (V)</label>
			<br>
      <label for="cu" class="leftLabel">Current (I):</label> <input type="number" v-model.number="current" step="any" @input="onCurrentChange" id="cu"> <label for="cu">amps (A)</label>
      <br>
      <label for="re" class="leftLabel">Resistance (R):</label> <input type="number" v-model.number="resistance" step="any" @input="onResistanceChange" id="re"> <label for="re">ohms (Ω)</label>
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "Ohm",
  data() {
    return {
      voltage: 1,
      current: 1,
      resistance: 1,
    }
  },
  components: {
    TopNav
  },
  methods: {
    onVoltageChange(e) {
      const voltage = e.currentTarget.value;
      this.resistance = voltage / this.current;
    },
    onCurrentChange(e) {
      const current = e.currentTarget.value;
      this.resistance = this.voltage / current;
    },
    onResistanceChange(e) {
      const resistance = e.currentTarget.value;
      this.current = this.voltage / resistance;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label.leftLabel {
  display: inline-block;
  width: 139px;
}

input[type=number] {
    width: 90px;
}

footer section a {
  margin: 20px;
}
</style>
